import React, { Component, PropTypes } from "react";
// import ReactHighcharts from 'react-highcharts';

import { NitroLoading } from "nitro-components";

import Highcharts from "highcharts";
import styled from "styled-components";

import RHC from "react-highcharts";

import dashboardTheme
	from "../../../../components/charts/highcharts-themes/smpl";
import {
	getColour
} from "../../../../components/charts/highcharts-themes/helper";
const ReactHighcharts = RHC.withHighcharts(Highcharts);

const Container = styled.div`
display: block;
min-width: 100%;

`;

class ReportDonutView extends Component {
	constructor(props) {
		super(props);
		this.clickLegend = this.clickLegend.bind(this);
	}
	componentDidMount() {
		const chartInstance = this.refs.chart.getChart();
		chartInstance.reflow = () => {};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.data !== this.props.data) {
			const chartInstance = this.refs.chart.getChart();
			chartInstance.reflow = () => {};
		}
	}

	clickLegend = params => {
		this.props.fetchReportDetail(params);
	};
	render() {
		const clickLegend = this.clickLegend;
		const { data, name, error, size } = this.props;
		let total = 0;

		if (data) {
			data.map((item, i) => {
				total = total + item.y;
			});
			const chartConfig = {
				chart: {
					type: "pie",
					height: 250,
					width: 465,
					events: {
						load: function() {
							const chart = this,
								rend = chart.renderer,
								pie = chart.series[0],
								left = chart.plotLeft + pie.center[0],
								top = chart.plotTop + pie.center[1],
								text = rend
									.text(total, left, top + 10)
									.attr({ "text-anchor": "middle" })
									.css({
										fontSize: "60px"
									})
									.add(),
								textTotal = rend
									.text("Total", left, top + 30)
									.attr({ "text-anchor": "middle" })
									.add();
						}
					}
				},
				legend: {
					width: 280,
					align: "right",
					verticalAlign: "middle",
					layout: "vertical",
					symbolHeight: -1, // Fix to avoid legend symbol appearing
        			symbolWidth: -1,  // Fix to avoid legend symbol appearing
        			symbolRadius: 0,
					useHTML: true,
					itemMarginBottom: 8,
					itemStyle: {
						color: "#000",
						fontFamily: "noto-sans-bold"
					},
					labelFormatter: function() {
						const notification = this.Notification
							? this.Notification
							: "";
						const notificationSpan = notification
							? `<span style='background:#FF632D;color: #fff;border-radius: 100px;padding: 3px 5px;font-size: 10px;margin-left: 10px;'>
									${this.Notification} new
									</span>`
							: "";
						return (
							"<div style='background: #F7F7F7;padding: 10px 20px;width: 230px;border-radius: 100px;'><div style='width:100%;color:" +
							this.color +
							"'><span style='width:50%'>" +
							this.name +
							"</span>" +
							notificationSpan +
							"<span style='color:#BBBBBB;float: right;'>></span><span style='width:20%;float: right;'>" +
							this.y +
							"</span></div></div>"
						);
					}
				},
				title: "",
				yAxis: {
					title: {
						text: ""
					}
				},
				plotOptions: {
					series: {
						animation: {
							duration: 2000
						}
					},
					pie: {
						size: "100%",
						point: {
							events: {
								legendItemClick: function() {
									clickLegend({
										FactRecordKeys: this.FactRecordKeys,
										Category: this.name
									});
									return false; // <== returning false will cancel the default action
								}
							}
						}
					}
				},
				tooltip: {
					formatter: function() {
						return (
							"<b>" + this.point.name + "</b>: " + this.y + " %"
						);
					}
				},
				credits: {
					enabled: false
				},
				exporting: { enabled: false },
				series: [
					{
						name: "",
						data: this.props.data,
						size: "120%",
						innerSize: "75%",
						showInLegend: true,
						dataLabels: {
							enabled: false
						}
					}
				]
			};

			const { id } = chartConfig;
			Highcharts.theme = dashboardTheme;
			const newTheme = {
				...dashboardTheme,
				colors: getColour(data.length)
			};
			Highcharts.setOptions(newTheme);

			return (
				<Container>
					<ReactHighcharts
						ref="chart"
						config={chartConfig}
						domProps={{ id }}
					/>
				</Container>
			);
		} else {
			return <NitroLoading center thickness={2} size={24} />;
		}
	}
}

ReportDonutView.propTypes = {
	data: PropTypes.array.isRequired,
	size: PropTypes.number,
	name: PropTypes.string,
	fetchReportDetail: PropTypes.func,
	error: PropTypes.bool // TODO .isRequired
};

export default ReportDonutView;



// WEBPACK FOOTER //
// ./src/features/dashboard/components/reports/ReportDonutView.js